<template>
  <transition name="bounce">
    <div class="sales-detail-view__container" v-if="show">
      <div class="css-grid sales-detail-view__row sales-detail-view__row--header" v-show="includeHeader">
        <div class="css-grid sales-detail-view__category sales-detail-view__category--month">
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--month">Month</div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--units">
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current">Units</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior">Prior</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change">Change</div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--sales">
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current">Sales</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior">Prior</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change">Change</div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--asp">
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--current">ASP</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--prior">Prior</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--header sales-detail-view__cell--change">Change</div>
        </div>
      </div>

      <div class="css-grid sales-detail-view__row" v-for="(month, index) in months" v-bind:key="`month.month-${index}`">
        <div class="css-grid sales-detail-view__category sales-detail-view__category--month">
          <div class="sales-detail-view__cell sales-detail-view__cell--month">{{ displayMonth(month.month, "mmm 'yy", true) }}</div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--units">
          <div class="sales-detail-view__cell sales-detail-view__cell--current">{{ currency(month.units) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--prior">{{ currency(month.yoy_units) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--change" v-bind:class="[ getChangePercent(month.units, month.yoy_units) >= 0 ? 'sales-detail-view__cell--positive' : 'sales-detail-view__cell--negative']">
            {{ getChangePercent(month.units, month.yoy_units) }}%
          </div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--sales">
          <div class="sales-detail-view__cell sales-detail-view__cell--current">${{ currency(month.sales) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--prior">${{ currency(month.yoy_sales) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--change" v-bind:class="[ getChangePercent(month.sales, month.yoy_sales) >= 0 ? 'sales-detail-view__cell--positive' : 'sales-detail-view__cell--negative']">
            {{ getChangePercent(month.sales, month.yoy_sales) }}%
          </div>
        </div>

        <div class="css-grid sales-detail-view__category sales-detail-view__category--asp">
          <div class="sales-detail-view__cell sales-detail-view__cell--current">${{ currency(divide(month.sales, month.units)) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--prior">${{ currency(divide(month.yoy_sales, month.yoy_units)) }}</div>
          <div class="sales-detail-view__cell sales-detail-view__cell--change" v-bind:class="[ getChangePercent(divide(month.sales, month.units), divide(month.yoy_sales, month.yoy_units)) >= 0 ? 'sales-detail-view__cell--positive' : 'sales-detail-view__cell--negative']">
            {{ getChangePercent(divide(month.sales, month.units), divide(month.yoy_sales, month.yoy_units)) }}%
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
  import DataMethods from '../../utils/DataMethods.js';

  export default {
    name: 'SalesDetails',
    mixins: [DataMethods],
    props: {
      months: {
        type: Array,
      },
      show: {
        type: Boolean,
        default: false
      },
      includeHeader: {
        type: Boolean,
        default: true
      },
    },
  };
</script>

